module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_txt2_m_jp.363d4d04f526efc0ec729535e9811070.png";